import { useEffect, useLayoutEffect } from "react"
import { NavigationType, useLocation, useNavigationType } from "react-router"
import { ScrollRestorationContext } from "./ScrollRestorationContext"

interface ScrollRestoreContentProps {
	register: (pathname: string) => void
	restore: () => void
	save: (pathname: string, scrollY: number) => void
}

const ScrollRestoreContent = ({ register, restore, save }: ScrollRestoreContentProps) => {
	const { pathname } = useLocation()
	const navigationType = useNavigationType()

	useEffect(() => {
		register(pathname)
	}, [register, pathname])

	useLayoutEffect(
		() => () => {
			// useLayoutEffect cleanup fires synchronously during the same commit that unmounts this
			// pathname, before react-router's own layout effect resets window.scrollY on the new page.
			// A plain useEffect cleanup would run after paint, by which point scrollY is already 0.
			save(pathname, window.scrollY)
		},
		[save, pathname],
	)

	useEffect(() => {
		if (navigationType === NavigationType.Pop) {
			// setTimeout is needed to make sure that restore is called after the navigation happened
			setTimeout(restore)
		}
	}, [navigationType, restore])

	return null
}

export const ScrollRestore = () => (
	<ScrollRestorationContext.Consumer>
		{({ register, restore, save }) => <ScrollRestoreContent register={register} save={save} restore={restore} />}
	</ScrollRestorationContext.Consumer>
)
